module.exports = __webpack_public_path__ + "img/nationalGeo.cbf9f583.jpg";